/**
 * @see https://github.com/sindresorhus/auto-bind/blob/master/index.js
 */

// Gets all non-builtin properties up the prototype chain
const getAllProperties = (object: any) => {
  const props = new Set<[any, string | number | symbol]>();

  do {
    for (const key of Reflect.ownKeys(object)) {
      props.add([object, key]);
    }
  } while ((object = Reflect.getPrototypeOf(object)) && object !== Object.prototype);

  return props;
};

export function autobind(self, _options: any = {}) {
  const options = { ..._options };

  const filter = (key) => {
    const match = (pattern) =>
      typeof pattern === "string" ? key === pattern : pattern.test(key);

    if (options.include) {
      return options.include.some(match);
    }

    if (options.exclude) {
      return !options.exclude.some(match);
    }

    return true;
  };

  for (const [object, key] of getAllProperties(self.constructor.prototype)) {
    if (key === "constructor" || !filter(key)) {
      continue;
    }

    const descriptor = Reflect.getOwnPropertyDescriptor(object, key);
    if (descriptor && typeof descriptor.value === "function") {
      self[key] = self[key].bind(self);
    }
  }

  return self;
}
